import {
    paymentType,
    requestTypes,
    leadStatuses,
    leadPayments,
} from '@/constants';

/**
 * @todo во втором итераций выпелем маппинг
 *
 * Возвращает тип оплаты
 *
 * @param {Number} status
 * @param {Boolean} [isPay] - для нецелевого лида, если true - счет оплчен, если false - счет неоплачен
 *
 * @return {Number}
 */
const getPayment = (status, isPay) => {
    if (status === 30 && !isPay) return paymentType.NOT_PAID;

    return leadPayments[status];
};

/**
 * Получаем тип нового лида
 *
 * @param {Object} data - данные лида
 * @return {Number}
 */
const getType = data => (data.type === requestTypes.CALL && data.isMissedCall ? requestTypes.MISSED : data.type);

/**
 * @todo во втором итераций выпелем маппинг
 *
 * Возвращает новые статуты
 *
 * @param {Number} status
 *
 * @return {Number}
 */
const getNewStatuses = status => leadStatuses[status];

/**
 * Для тестовом окружение, используется другие треки, т.к. наши не работаает
 *
 * @return {string}
 */
const getTestRecord = () => {
    const exampleTracks = [
        'https://howlerjs.com/assets/howler.js/examples/player/audio/80s_vibe.mp3',
        'https://howlerjs.com/assets/howler.js/examples/player/audio/rave_digger.mp3',
        'https://howlerjs.com/assets/howler.js/examples/player/audio/running_out.mp3',
    ];

    return exampleTracks[(Math.floor(Math.random() * exampleTracks.length))];
};

/**
 * Задает лид, создовая новое поля для админки
 *
 * @todo как откажемся от старых админок, выпилить
 * @param {Object} data - данные лида
 * @param index
 * @return {Object}
 */
const setLead = (data, index) => ({
    ...data,
    commentAgent: data.commentAgent ? data.commentAgent : '',
    index,
    newStatus:    getNewStatuses(data.status),
    payment:      getPayment(data.status, data.client),
    type:         getType(data),
    ...(data.recording && { recording: import.meta.env.DEV
        ? getTestRecord()
        : data.recording }),
});

export default {

    /**
   * Обработать лид. Удаляет из state по индексу.
   *
   * @param {Object} state - Vuex.state
   * @param {Number} index - Индекс лида
   */
    HANDLE_LEAD(state, index) {
        state.data.splice(index, 1);
    },

    /**
   * Обработать несколько лидов. Удаляет из state по массиву.
   *
   * @param {Object} state - Vuex.state
   * @param {Object[]} array - массив выбранных лидов
   */
    HANDLE_LEADS(state, array) {
        const arrayCopy = JSON.parse(JSON.stringify(array));

        for (let i = 0; i < arrayCopy.length; i++) {
            const index = state.data.findIndex(item => item.id === arrayCopy[i].id);

            state.data.splice(index, 1);
        }

        state.unprocessedSelected = [];
    },

    /**
     * Сетим данные по графику (pie chart)
     *
     * @param {Object} state - state в store
     * @param {Object} data - данные из Бэка
     */
    SET_GRAPH(state, data) {
        state.graph = data;
    },

    /**
   * Задаем определенную лид
   *
   * @param {Object} state - state в store
   * @param {Object} payload
   * @param {Object[]} payload.data - данные из Бэка
   * @param {Number} payload.index - индекс изменяемого объекта
   */
    SET_LEAD(state, { data, index }) {
        if (!state.data || (state.data && !state.data.length)) return;

        state.data.splice(index, 1, setLead(data, index));
    },

    /**
   * Задаем лиды
   *
   * @param {Object} state - state в store
   * @param {Object} payload
   * @param {Object[]} payload.data - данные из Бэка
   * @class SET_LEADS
   */
    SET_LEADS(state, { data }) {
        state.data = [];

        for (const [index, item] of data.entries()) {
            state.data.push(setLead(item, index));
        }
    },

    /**
   * Обновляем комментарий
   *
   * @param {Object} state - Vuex.state
   * @param {Object} payload
   * @param {Number} payload.index - Индекс лида
   * @param {String} payload.newComment - Новое комментарий
   */
    UPDATE_COMMENT(state, { index, newComment }) {
        const copyData = JSON.parse(JSON.stringify(state.data[index]));

        state.data.splice(index, 1, { ...copyData, commentAgent: newComment });
    },

    /**
   * Обновить состояние лида показать номер
   *
   * @param {Object} state - Vuex.state
   * @param {Object} payload
   * @param {Number} payload.index - индекс лида
   * @param {Boolean} payload.bool - новое состояние
   */
    UPDATE_PHONE_SHOWED(state, { index, bool }) {
        state.data[index].isPhoneShowed = bool;
    },

    /**
   * Обновить используемые параметры для получение списка лидов
   *
   * @param {Object} state - Vuex.state
   * @param {Object} params - Новые параметры
   */
    UPDATE_SELECTED_PARAMS(state, params) {
        state.selectedParams = params;
    },

    /**
   * Обновить общее количество лидов выбранных параметрах
   *
   * @param {Object} state - Vuex.state
   * @param {number} count - Новое общее количество лидов
   */
    UPDATE_TOTAL_COUNT(state, count) {
        state.totalCount = count;
    },

    /**
   * Обновить показатель "Необработанные лиды"
   *
   * @param {Object} state - Vuex.state
   * @param {Number} inc - новое число необработанных лидов
   */
    UPDATE_UNPROCESSED_COUNT(state, inc) {
        state.unprocessedCount = inc;
    },

    /**
   * Обновить показатель "Необработанные лиды"
   *
   * @param {Object} state - Vuex.state
   * @param {Object[]} array - Выбранные лиды
   */
    UPDATE_UNPROCESSED_SELECTED(state, array) {
        state.unprocessedSelected = array;
    },
};
